import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50 rounded-t-3xl mx-4 md:mx-6 mt-20">
      <div className="px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[2fr_1fr_1.5fr] gap-10">
          <div>
            <Link
              to="/"
              className="font-heading text-3xl tracking-tight block mb-3 cursor-pointer hover:text-primary-400 transition-colors"
            >
              pandabuy<span className="text-primary-500">.help</span>
            </Link>
            <p className="text-foreground-300 text-sm max-w-sm leading-relaxed">
              The #1 curated Pandabuy spreadsheet discovery hub. Browse organized, verified Pandabuy finds across sneakers, streetwear, tech, and luxury categories.
            </p>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-wider text-foreground-400 mb-4">
              Categories
            </h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer underline underline-offset-4 decoration-foreground-700 hover:decoration-background-50 whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-wider text-foreground-400 mb-4">
              Quick Links
            </h4>
            <div className="flex flex-col gap-2.5">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer underline underline-offset-4 decoration-foreground-700 hover:decoration-background-50 whitespace-nowrap"
              >
                Pandabuy Sheet — Main Site
              </a>
              <Link
                to="/blog/pandabuy-spreadsheet-guide"
                className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer underline underline-offset-4 decoration-foreground-700 hover:decoration-background-50 whitespace-nowrap"
              >
                Complete Pandabuy Guide
              </Link>
              <a
                href={`${mainSiteUrl}/category-911-Shoes.html`}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer underline underline-offset-4 decoration-foreground-700 hover:decoration-background-50 whitespace-nowrap"
              >
                Shoes Collection
              </a>
              <a
                href={`${mainSiteUrl}/search-919/name/Shoes.html`}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer underline underline-offset-4 decoration-foreground-700 hover:decoration-background-50 whitespace-nowrap"
              >
                Jersey Collection
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/50 px-6 md:px-10 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-400">
          <div className="flex items-center gap-5">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="hover:text-background-50 transition-colors cursor-pointer underline underline-offset-4 whitespace-nowrap"
            >
              kaspreadsheet.com
            </a>
          </div>
          <p className="whitespace-nowrap">
            &copy; {new Date().getFullYear()} pandabuy.help — Curated Pandabuy Spreadsheet Hub
          </p>
          <p className="text-foreground-500 whitespace-nowrap">
            We do not sell products. Informational site only.
          </p>
        </div>
      </div>
    </footer>
  );
}